import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-processing-overlay',
  template: ` <mat-spinner diameter="44"></mat-spinner>
    <div class="overlay-title">{{ title }}</div>
    <div class="overlay-subtitle">{{ subtitle }}</div>`,
  styleUrl: './payment-processing-overlay.component.scss'
})
export class PaymentProcessingOverlayComponent {
  @Input() title = 'Processing Payment';
  @Input() subtitle = 'Please do not close or refresh this page.';
}
